import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaHome,
  FaUsers,
  FaHardHat,
  FaTruck,
  FaCog,
  FaChartLine,
  FaFileContract,
  FaWarehouse,
  FaTools,
  FaChevronDown,
  FaChevronRight,
  FaQuestionCircle,
} from "react-icons/fa";
import "./DashboardSidebar.css";

const DashboardSidebar = ({ userRole }) => {
  const location = useLocation();
  const [expandedMenus, setExpandedMenus] = useState({});

  // Menu configuration
  const menuConfig = {
    common: [],
    admin: [
      { path: "/AdminDashboard", icon: <FaHome />, label: "Dashboard" },
      {
        path: "/AdminDashboard/CompanyMaintenance",
        icon: <FaUsers />,
        label: "Companies",
      },
      {
        path: "/AdminDashboard/CategoryMaintenance",
        icon: <FaHardHat />,
        label: "Categories",
      },
      {
        path: "/AdminDashboard/EquipmentMaintenance",
        icon: <FaTools />,
        label: "Equipment",
      },
      {
        path: "/AdminDashboard/UserMaintenance",
        icon: <FaUsers />,
        label: "Users",
      },
      {
        path: "/AdminDashboard/AllOrders",
        icon: <FaTruck />,
        label: "All Orders",
      },
      {
        path: "/AdminDashboard/PaymentVerifications",
        icon: <FaChartLine />,
        label: "Payments",
      },
      {
        path: "/AdminDashboard/CommissionLedgerReport",
        icon: <FaChartLine />,
        label: "Commission",
      },
      {
        path: "/AdminDashboard/SupplierPayment",
        icon: <FaChartLine />,
        label: "Supplier Pay",
      },
      {
        path: "/AdminDashboard/BlogMaintenance",
        icon: <FaChartLine />,
        label: "Blogs",
      },
      {
        path: "/AdminDashboard/Settings",
        icon: <FaCog />,
        label: "Settings",
      },
    ],
    supplier: [
      { path: "/SupplierDashboard", icon: <FaHome />, label: "Dashboard" },
      {
        path: "/SupplierDashboard/CompanyMaintenance",
        icon: <FaUsers />,
        label: "Companies",
      },
      {
        path: "/SupplierDashboard/CategoryMaintenance",
        icon: <FaHardHat />,
        label: "Categories",
      },
      {
        path: "/SupplierDashboard/EquipmentMaintenance",
        icon: <FaTools />,
        label: "Equipment",
      },
      {
        path: "/SupplierDashboard/SupplierLedger",
        icon: <FaWarehouse />,
        label: "Ledger",
      },
      {
        path: "/SupplierDashboard/ChangePassword",
        icon: <FaCog />,
        label: "Password",
      },
    ],
    renter: [
      { path: "/RenterDashboard", icon: <FaHome />, label: "Dashboard" },
      {
        path: "/RenterDashboard/RenterOrderManagement",
        icon: <FaTruck />,
        label: "My Orders",
      },
      {
        path: "/RenterDashboard/RenterPayment",
        icon: <FaChartLine />,
        label: "Payments",
      },
      {
        path: "/RenterDashboard/ChangePassword",
        icon: <FaCog />,
        label: "Password",
      },
    ],
  };

  // Get menu items based on role
  const getMenuItems = () => {
    let items = [...menuConfig.common];
    switch (userRole) {
      case "Admin":
        return [...items, ...menuConfig.admin];
      case "Supplier":
        return [...items, ...menuConfig.supplier];
      default:
        return [...items, ...menuConfig.renter];
    }
  };

  return (
    <aside className="dashboard-sidebar">
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <span className="logo-short">EQ</span>
          <span className="logo-full">Equipment Hub</span>
        </div>
      </div>
      <nav className="sidebar-nav">
        <ul>
          {getMenuItems().map((item, index) => {
            const isActive = location.pathname === item.path;
            return (
              <li key={index} className={isActive ? "active" : ""}>
                <Link to={item.path} className="menu-item">
                  <span className="menu-icon">{item.icon}</span>
                  <span className="menu-label">{item.label}</span>
                  {isActive && <div className="active-indicator"></div>}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
      <div className="sidebar-footer">
        <div className="help-section">
          <span className="help-icon">
            <FaQuestionCircle />
          </span>
          <div className="help-content">
            <h4>Need help?</h4>
            <a href="/support" className="support-link">
              Contact Support
            </a>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default DashboardSidebar;